export default "/public/dist/img/IMG1.png";